import { useMemo } from "react";

const COLORS = [
    "text-slate-500", "text-blue-500", "text-violet-600", "text-indigo-700", "text-slate-900",
];

export default function CssWordCloud({ words, maxWords = 40 }) {
    const sized = useMemo(() => {
        const slice = words.slice(0, maxWords);
        if (slice.length === 0) return [];
        const max = slice[0]?.count || 1;
        const min = slice[slice.length - 1]?.count || 1;
        const range = max - min || 1;
        return slice.map((w) => {
            const norm = (w.count - min) / range;
            const size = 14 + norm * 34;
            const colorIdx = Math.min(Math.floor(norm * COLORS.length), COLORS.length - 1);
            return { ...w, size, color: COLORS[colorIdx] };
        });
    }, [words, maxWords]);

    if (sized.length === 0) {
        return <p className="text-sm text-slate-400 text-center py-8">No data yet</p>;
    }

    return (
        <div className="flex flex-wrap justify-center items-baseline gap-x-3 gap-y-1 py-4">
            {sized.map((w) => (
                <span key={w.word} className={`${w.color} font-medium leading-tight cursor-default transition-opacity hover:opacity-70`}
                    style={{ fontSize: `${w.size}px` }} title={`${w.word}: ${w.count}`}>
                    {w.word}
                </span>
            ))}
        </div>
    );
}
